/* eslint-disable @typescript-eslint/no-unused-vars */
'use client';
import CheckExpiryModal from '@/features/check-expiry/CheckExpiryModal';
import Preloader from '@/features/preloader/components/Preloader';
import { useFetcherCSR } from '@/lib/useFetcherCSR';
import { useEffect, useState } from 'react';

const VerifyProduct = () => {
  const [selectedBrand, setSelectedBrand] = useState<any>('');
  const [batchId, setBatchId] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [responseMessage, setResponseMessage] = useState<string>('');
  const [responseClass, setResponseClass] = useState<string>('');
  const [verificationResult, setVerificationResult] = useState<any>(null);

  const { data: brands, isLoading } = useFetcherCSR(`/api/v2/brands`);

  const handleBrandChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const brandId = parseInt(e.target.value);
    const selected = brands?.data?.find((brand: any) => brand.id === brandId);
    setSelectedBrand(selected || null);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setResponseMessage('');
    setResponseClass('');

    if (!selectedBrand || !batchId) {
      setResponseMessage('Please select a brand and enter a batch ID');
      setResponseClass('text-danger');
      setLoading(false);
      return;
    }

    try {
      const response = await fetch(
        'https://ecommerceapp.thetork.com/api/v2/verify-products/check',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            batch_id: batchId,
            brand_id: selectedBrand.id,
          }),
        }
      );

      const result = await response.json();

      if (response.ok) {
        setVerificationResult(result.data);
        setShowModal(true);
      } else {
        setResponseMessage(result.message || 'Verification failed');
        setResponseClass('text-danger');
      }
    } catch (error) {
      console.error('Error verifying product:', error);
      setResponseMessage('An error occurred while verifying the product');
      setResponseClass('text-danger');
    } finally {
      setLoading(false);
    }
  };

  const closeModal = () => {
    setShowModal(false);
  };

  if (isLoading) return <Preloader />;

  return (
    <>
      <section className="page-header">
        <div className="container">
          <div className="page-header__content">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb justify-content-start mb-0">
                <li className="breadcrumb-item ">
                  <a href="/">Verify Product</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Verify your product
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </section>

      <section className="check-expiry padding-bottom">
        <div className="container">
          <div className="row g-4">
            <div className="col-12">
              <h3 className="mt-6 fw-semibold mb-2">
                EXPIRY DATE OF COSMETICS CHECK TOOL
              </h3>

              <form className="mb-3" onSubmit={handleSubmit}>
                <div className="row align-items-center g-4">
                  <div className="col-md-5">
                    <div className="form-group">
                      <label className="mb-1">Search & Select a Brand</label>
                      <select
                        className="form-select height-adjust mb-0"
                        value={selectedBrand?.id || ''}
                        onChange={handleBrandChange}
                        required
                      >
                        <option value="">Select Brand</option>
                        {brands?.data?.map((brand: any) => (
                          <option key={brand.id} value={brand.id}>
                            {brand.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  <div className="col-md-5">
                    <div className="form-group">
                      <label htmlFor="batch-id" className="mb-1">
                        Batch ID <span className="required">*</span>
                      </label>
                      <input
                        type="text"
                        placeholder="Batch ID"
                        id="batch-id"
                        name="batch-id"
                        value={batchId}
                        onChange={(e) => setBatchId(e.target.value)}
                        required
                        className="form-control"
                      />
                    </div>
                  </div>

                  <div className="col-md-2">
                    <div className="form-footer mt-2">
                      <button
                        type="submit"
                        className="trk-btn trk-btn--primary font-weight-normal mt-md-3"
                        disabled={loading}
                      >
                        {loading ? 'Checking...' : 'Check'}
                      </button>
                    </div>
                  </div>
                </div>
                {responseMessage && (
                  <div className={`mt-3 ${responseClass}`}>
                    {responseMessage}
                  </div>
                )}
              </form>
            </div>

            {showModal && verificationResult && (
              <CheckExpiryModal
                show={showModal}
                handleClose={closeModal}
                selectedBrand={selectedBrand}
                verificationResult={verificationResult}
              />
            )}
            <div className="col-12">
              <h3 className="mt-5 fw-medium mb-2">
                How to use batch code checker – cosmetic calculator
              </h3>
              <div className="mb-3">
                <p>
                  <strong>Step 1</strong>: Search brand and select a brand.
                </p>
              </div>
              <div className="mb-3">
                <p>
                  <strong>Step 2</strong>: Find the batch code on the product
                  and fill in the batch code box.
                  <strong>Step 2</strong>: Find the batch code on the product
                  and fill in the batch code box.
                </p>
                <img
                  width="300"
                  alt="image"
                  src="/images/product-verify/image.png"
                />
              </div>
              <div className="mb-3">
                <p>
                  You can find it on the product packages. The
                  manufacturers&rsquo; names are also printed on the packages.
                  You can scan the Barcodes, QR Codes on the product packaging
                  on Google to get more information about the product. You can
                  copy products&lsquo; names, websites, or hotlines on the
                  package and search them on Google to get more information
                  about the products such as manufacturers, ingredients,
                  benefits, uses…
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default VerifyProduct;
